import { useEffect } from 'react';
import { setWbIntegrationEnabled, useAppDispatch } from '@/app/store';
import { useGetWildberriesIntegrationExistsQuery } from '@/entities/analitics';

export const useActualiseWbIntegration = () => {
  const dispatch = useAppDispatch();
  const { data } = useGetWildberriesIntegrationExistsQuery();

  useEffect(() => {
    dispatch(setWbIntegrationEnabled(!!data?.data));
  }, [dispatch, data?.data]);
};
